// extracted by mini-css-extract-plugin
module.exports = {"btn":"DisableUser_btn__3_CHI"};